import {endsWith} from '../utils/stringUtils';

export const MIMETypes = {
  MP4: 'video/mp4',
  WEBM: 'video/webm',
  HLS: 'application/x-mpegURL',
  DASH: 'application/dash+xml',
} as const;

/**
 * @deprecated use {@link getStreamTypesFromURL} directly, when we want to detect {@link StreamTypes} from URL
 *
 * @remarks
 *
 * In our current code, it is visible that detection of MIME Type is only used as "an additional step" between
 * stream URL and stream type:
 *  - we parse stream URL to detect MIME type
 *  - we parse the detected MIME type to get a stream type
 *
 * Because we are not sending the detected MIME type in sample and because we can get {@link StreamTypes} directly from
 * stream URL, we should stop using this MIME type detection code.
 */
export function getMIMETypeFromFileExtension(url: string): string | undefined {
  const urlPath = url.split(/[?#]/)[0].toLowerCase();

  if (endsWith(urlPath, '.m3u8')) {
    return MIMETypes.HLS;
  }
  if (endsWith(urlPath, '.mp4') || endsWith(urlPath, '.m4v') || endsWith(urlPath, '.m4a')) {
    return MIMETypes.MP4;
  }
  if (endsWith(urlPath, '.webm')) {
    return MIMETypes.WEBM;
  }
  if (endsWith(urlPath, '.mpd')) {
    return MIMETypes.DASH;
  }

  return undefined;
}
